import { render } from "./Sketch.vue?vue&type=template&id=67f5e6c6&scoped=true&ts=true"
import script from "./Sketch.vue?vue&type=script&lang=ts"
export * from "./Sketch.vue?vue&type=script&lang=ts"

import "./Sketch.vue?vue&type=style&index=0&id=67f5e6c6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f5e6c6"]])

export default __exports__